import styled from 'styled-components';
import { appLeftPadding } from '../../../../constants/theme';

export const Header = styled.header`
  margin: 7rem 0 6rem 0;
  padding-left: ${appLeftPadding};
  position: relative;
`;
